export default "__VITE_ASSET__64752cff__"